<template>
  <div class="interview-material" v-if="interviewData">
    <div class="material-tips-box">{{ materialTips }}</div>
    <div class="applicant-interview-masterial">
      <div
        class="applicant-item"
        v-for="(applicant, index) in interviewData.applicant_material"
        :key="index"
      >
        <div class="item-header">{{ applicant.name }}</div>
        <div class="material-list">
          <div
            v-if="applicant.photo"
            class="material-item"
            @click="previewFile(applicant.photo, '证件照')"
          >
            <img class="item-icon" :src="getFileIcon(applicant.photo)" />
            <div class="item-info">
              <div class="item-name" :src="applicant.photo" preview="1">
                证件照.{{ getFileInfoByUrl(applicant.photo).suffix }}
              </div>
            </div>
          </div>

          <div
            class="material-item"
            v-for="(material, materialIndex) in applicant.material_file_set"
            :key="materialIndex"
            @click="previewFile(material.url, getMaterialName(material))"
          >
            <img class="item-icon" :src="getFileIcon(material.url)" />
            <div class="item-info">
              <div class="item-name">{{ getMaterialName(material) }}</div>
              <div class="item-not-upload" v-if="!material.url">
                暂未上传，资料操作完毕后，您将收到上传提醒
              </div>
              <div
                class="item-not-upload"
                v-else-if="isCanadaApplication && material.attr === 13"
              >
                电子申请表请务必保存文件至U盘，和其他资料一起递交到使馆
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- iphonex兼容占位块 -->
    <div class="fix-full-screen-height"></div>

    <div class="preview-footer fix-full-screen-bottom">
      <button class="send-btn" @click="showSendEmailDialog = true">
        发送赴馆通知书到邮箱
      </button>
    </div>

    <interview-send-email-dialog
      :show.sync="showSendEmailDialog"
      :user_order_id="params.user_order_id"
      :order_applicant_id="params.order_applicant_id"
    ></interview-send-email-dialog>
  </div>
</template>

<script>
import InterviewSendEmailDialog from '../components/InterviewSendEmailDialog.vue';
import countryService from '../services/countryService';
import util from '../services/tools.js';
import http from '../services/http';

export default {
  name: '',
  components: {
    InterviewSendEmailDialog,
  },
  data() {
    return {
      params: {
        user_order_id: 0,
        order_applicant_id: 0,
      },
      isInnerApp: true, // 是否在APP内
      showSendEmailDialog: false,
      interviewData: null,
      os: '',
      appVersion: '',
      WX: false,
    };
  },
  computed: {
    // 是否是美国面试
    isAmericaInterview() {
      if (!this.interviewData) return false;
      return (
        this.interviewData.visa_country_id ===
          countryService.getCountryId('america') &&
        this.interviewData.need_interview
      );
    },
    // 是否事加拿大+需要面递申请表，需要禁用
    isCanadaApplication() {
      if (!this.interviewData) return false;
      return (
        this.interviewData.visa_country_id ===
          countryService.getCountryId('canada') &&
        this.interviewData.need_ca_application
      );
    },
    // 资料的打印提示
    materialTips() {
      if (!this.interviewData.country) return;
      if (this.interviewData.companion_name) {
        // 陪签
        if (this.isAmericaInterview) {
          return '注：请查阅并核对下述资料，照片（尺寸为5.1*5.1cm）请自行携带，其他资料将由陪签员携带到签证中心，收到后请仔细核对。若您期间更改过预约时间，请查阅最新的邮件。';
        }
        return `注：请查阅并核对下述资料，资料将由陪签员携带到签证中心，收到后请仔细核对。若您期间更改过面签预约时间，请查阅最新的邮件信息。${
          this.isCanadaApplication
            ? '电子申请表请务必保存文件至U盘，和其他资料一起递交到使馆。'
            : ''
        }`;
      }
      // 不陪签
      if (this.isAmericaInterview) {
        return '注：以下资料需自行打印出来、携带赴馆，照片尺寸为5.1*5.1cm。若签证专家已邮寄资料，但您申请重新预约，请重新下载，并自行打印替换原资料。';
      }
      return `注：以下资料需自行打印出来、携带赴馆，若签证专家已邮寄资料，但您申请重新预约，请重新下载，并自行打印替换原资料。${
        this.isCanadaApplication
          ? '电子申请表请务必保存文件至U盘，和其他资料一起递交到使馆。'
          : ''
      }`;
    },
    supportPreview() {
      if (
        this.isInnerApp &&
        !this.WX &&
        this.os === 'android' &&
        !this.appVersion
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {},
  created() {
    this.params.user_order_id = +this.$route.params.orderId;
    this.params.order_applicant_id = +this.$route.params.applicantId;
    if (!this.params.user_order_id || !this.params.order_applicant_id) return;
    this.WX = util.isWeixin();
    this.os = util.getOS();

    if (!window.WebViewJavascriptBridge) {
      this.isInnerApp = false;
    } else {
      util.getBridge((bridge) => {
        bridge.callHandler('get_app_info', {}, (data) => {
          const authData = typeof data === 'string' ? JSON.parse(data) : data;
          this.appVersion = authData.ver;
        });
      });
    }

    util.init();
    this.getInterviewInfo();
  },
  methods: {
    getFileInfoByUrl: util.getFileInfoByUrl,

    // 获取文件icon
    getFileIcon(url) {
      if (url.indexOf('.pdf') > -1) {
        return 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvwxa/order/file-icon/icon-pdf.png';
      } else if (url.indexOf('.doc') > -1) {
        return 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvwxa/order/file-icon/icon-doc.png';
      } else if (url.indexOf('.xls') > -1) {
        return 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvwxa/order/file-icon/icon-excel.png';
      }
      return 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvwxa/order/file-icon/icon-img.png';
    },
    // 获取详情
    getInterviewInfo() {
      http
        .post('h5/applicant_interview_query', {
          order_applicant_id: this.params.order_applicant_id,
          is_app: 1,
        })
        .then((res) => {
          this.interviewData = res.body.body;
        });
    },

    getMaterialName(material) {
      return `${material.name}${
        this.getFileInfoByUrl(material.url).suffix
          ? `.${this.getFileInfoByUrl(material.url).suffix}`
          : ''
      }`;
    },
    previewFile(url, title) {
      if (!this.supportPreview) return;
      if (!url) return;
      if (this.isInnerApp) {
        util.getBridge((bridge) => {
          bridge.callHandler('previewPDF', { url, title }, () => {});
        });
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.interview-material {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding-bottom: 0.76rem;

  .material-tips-box {
    background-color: #fffaed;
    padding: 0.08rem 0.12rem;
    color: #ff7012;
    font-size: 0.12rem;
    line-height: 0.16rem;
  }
  .applicant-interview-masterial {
    padding: 0.12rem;
    .applicant-item {
      background: #ffffff;
      box-shadow: 0 0.1rem 0.25rem -0.05rem rgba(131, 146, 167, 0.12);
      border-radius: 0.08rem;
      padding: 0.16rem 0.12rem;
      margin-bottom: 0.12rem;
      &:last-child {
        margin-bottom: 0;
      }
      .item-header {
        display: flex;
        align-items: center;
        font-size: 0.17rem;
        line-height: 1;
        color: #333;
        font-weight: 500;
      }
      .material-list {
        margin-top: 0.16rem;
        .material-item {
          background: #fafafa;
          border-radius: 0.08rem;
          border: 0.01rem solid #e0e0e0;
          padding: 0.12rem;
          margin-bottom: 0.1rem;
          display: flex;
          align-items: center;
          &:last-child {
            margin-bottom: 0;
          }
          .item-icon {
            width: 0.4rem;
            height: 0.4rem;
            flex-shrink: 0;
          }
          .item-info {
            margin-left: 0.12rem;
            flex-grow: 1;
            overflow: hidden;
            .item-name {
              color: #333;
              font-size: 0.14rem;
              line-height: 0.2rem;
            }
            .item-not-upload {
              margin-top: 0.04rem;
              color: #ff4b4d;
              font-size: 0.12rem;
              line-height: 0.16rem;
            }
          }
        }
      }
    }
  }

  .preview-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 10;
    height: 0.64rem;
    background: #ffffff;
    padding: 0.1rem 0.11rem 0.09rem 0.11rem;
    .send-btn {
      height: 0.45rem;
      border-radius: 0.23rem;
      background: linear-gradient(153deg, #ff6052 0%, #ff4b4d 100%);
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 0.16rem;
      font-weight: 500;
      border: none;
      outline: none;
    }
  }
}
</style>
